export enum ThankYouMessage {
  Register = 'register',
  RegisterPendingFinance = 'register-pending-finance',
  AccountError = 'account-error',
}
